import { Dictionary, EntityId } from '@reduxjs/toolkit';
import { GiftJson } from './GiftJson';

export const toActiveInputs = (variableIds: EntityId[], inputs: Dictionary<GiftJson.Input<any>>) => {
    const activeInputs: Dictionary<GiftJson.Input<any>> = {};
    variableIds.forEach(id => activeInputs[id] = inputs[id]!);
    return activeInputs;
};